import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from '../common/media_query';
import Ad from '../common/ad';

const ADHESION_AD_SIZES = [
  [1, 1],
  [320, 51],
  [320, 100]
];

const AdhesionAd = ({ adsState }) => (
  <div className="row footer-ad oop-ad-unit-container">
    <MediaQuery breakpoint="mobile">
      <div className="footer-ad-mobile">
        <Ad
          outOfPage
          adsState={adsState}
          sizes={ADHESION_AD_SIZES}
          position="adhesion"
          uniqueId="mobile-out-of-page"
          shouldDisplayImmediately
        />
      </div>
    </MediaQuery>
    <MediaQuery breakpoint="desktop">
      <div className="footer-ad-desktop">
        <Ad
          adsState={adsState}
          sizes={ADHESION_AD_SIZES}
          position="adhesion"
          uniqueId="mobile-out-of-page"
          shouldDisplayImmediately
        />
      </div>
    </MediaQuery>
  </div>
);

AdhesionAd.propTypes = {
  adsState: PropTypes.object.isRequired
};

export default AdhesionAd;
